import { render, staticRenderFns } from "./CompanyDocuments.vue?vue&type=template&id=23b6b9bf&scoped=true&"
import script from "./CompanyDocuments.vue?vue&type=script&lang=ts&"
export * from "./CompanyDocuments.vue?vue&type=script&lang=ts&"
import style0 from "./CompanyDocuments.vue?vue&type=style&index=0&id=23b6b9bf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b6b9bf",
  null
  
)

export default component.exports